const getAlarms = function(fn) {

  const init = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Basic '+btoa('myapiuser:123456'),
    }
  };

  fetch('/api/alarms', init)
    .then(response => {
      return response.json();
    }).then(json => {
      fn(json);
    }).catch(function(err) {
      console.log('parsing failed', err);
    });

}

export {
  getAlarms
};



// WEBPACK FOOTER //
// ./src/requests/getAlarms.js